"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = function _default(_ref) {
  var style = _ref.style;
  var classes = 'skeleton bg-secondary';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full p-4 pt-0 relative",
    style: _objectSpread(_objectSpread({}, style), {}, {
      zIndex: 4
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-full p-4 shadow-lg bg-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-12 h-12 rounded-full flex-shrink-0')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full ml-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-1/2 h-4')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-2/3 h-3 mt-1')
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm font-semibold truncate text-dark my-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-2/3 h-2 my-2')
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center",
    style: {
      height: 23
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-12 h-4')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes, 'w-12 h-4 ml-4')
  }))));
};

exports["default"] = _default;
//# sourceMappingURL=SenderCard.js.map